import { min } from 'd3-array';
import moment from 'moment';
import { FC } from 'react';

import { useGetFcos } from '../../../api/fcos';
import { FCOFields, FeatureViewFCO } from '../../../core/types/fcoTypes';
import { useUserSettings } from '../../context/UserSettingsContext';
import ValidationsFilterProvider from './FiltersContext';
import { ValidationsContextProvider } from './ValidationsContext';
import { Loading, ViewLayout } from '@lithos';
import ValidationsTableView from './ValidationsTableView';

const ValidationsContainer: FC = () => {
  const { workspace } = useUserSettings();

  const { data, isLoading } = useGetFcos(workspace ?? '', {});

  const headerProps = {
    breadcrumbs: {
      root: {
        label: workspace ?? '',
        url: `/repo/${workspace}`,
      },
      items: [{ label: 'Data Quality' }],
    },
    title: 'Data Quality',
  };

  if (isLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  const earliestStartDate = min(
    data.featureViews.map((featureView: FeatureViewFCO) => {
      return new Date(featureView[FCOFields.CREATED_DATE]!);
    })
  );

  const endDate = moment();

  return (
    <ViewLayout
      header={headerProps}
      content={
        <ValidationsContextProvider dateRange={[moment(earliestStartDate), endDate]}>
          <ValidationsFilterProvider>
            <ValidationsTableView />
          </ValidationsFilterProvider>
        </ValidationsContextProvider>
      }
    />
  );
};

export default ValidationsContainer;
